/**
 * Mercola Market — Global JavaScript
 *
 * Handles: cart AJAX (quantity update, remove), variant selection,
 * autoship toggle, breadcrumbs, newsletter form feedback.
 */
(function() {
  'use strict';

  // ============================================================
  // Cart AJAX — quantity update + remove
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    // Quantity buttons (+/-)
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quantity-change]');
      if (!btn) return;

      e.preventDefault();
      var line = btn.getAttribute('data-line');
      var direction = btn.getAttribute('data-quantity-change');
      var input = btn.parentElement.querySelector('[data-quantity-input]') ||
                  btn.parentElement.querySelector('input[type="number"]');
      var currentQty = input ? parseInt(input.value) || 1 : 1;
      var newQty = direction === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

      if (newQty === 0) {
        removeCartItem(line);
      } else {
        updateCartItem(line, newQty);
      }
    });

    // Remove button
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;

      e.preventDefault();
      var line = btn.getAttribute('data-line') || btn.getAttribute('data-cart-remove');
      removeCartItem(line);
    });

    // Quantity input change
    document.addEventListener('change', function(e) {
      var input = e.target.closest('[data-quantity-input]');
      if (!input) return;

      var line = input.getAttribute('data-line');
      var newQty = parseInt(input.value) || 0;
      if (newQty === 0) {
        removeCartItem(line);
      } else {
        updateCartItem(line, newQty);
      }
    });
  });

  function updateCartItem(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line), quantity: quantity })
    })
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      refreshCartPage(cart);
      updateCartCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    })
    .catch(function(err) { console.error('Cart update failed:', err); });
  }

  function removeCartItem(line) {
    updateCartItem(line, 0);
  }

  function refreshCartPage(cart) {
    // Use Shopify Section Rendering API if on cart page
    if (window.location.pathname === '/cart') {
      fetch('/cart?sections=main-cart-items')
        .then(function(res) { return res.json(); })
        .then(function(sections) {
          var cartSection = document.querySelector('[data-cart-section]') ||
                           document.querySelector('.cart') ||
                           document.getElementById('main-cart-items');
          if (cartSection && sections['main-cart-items']) {
            var temp = document.createElement('div');
            temp.innerHTML = sections['main-cart-items'];
            var newContent = temp.querySelector('[data-cart-section]') ||
                           temp.querySelector('.cart') || temp;
            if (cartSection && newContent) {
              cartSection.innerHTML = newContent.innerHTML;
            }
          }
        })
        .catch(function() {
          // Fallback: full page reload
          window.location.reload();
        });
    }
  }

  function updateCartCount(count) {
    var badges = document.querySelectorAll('.header__cart-count, [data-cart-count]');
    badges.forEach(function(badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ============================================================
  // Autoship Toggle
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    var toggle = document.querySelector('[data-autoship-toggle]');
    if (!toggle) return;

    toggle.addEventListener('change', function() {
      var isAutoship = this.checked;
      var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
      var priceDisplay = document.querySelector('[data-autoship-price]');
      var regularPrice = document.querySelector('[data-regular-price]');

      if (isAutoship && sellingPlanInput) {
        // Set the selling plan ID (5% autoship discount)
        var planId = this.getAttribute('data-selling-plan-id');
        sellingPlanInput.value = planId || '';
        if (priceDisplay) priceDisplay.style.display = 'block';
        if (regularPrice) regularPrice.style.display = 'none';
      } else if (sellingPlanInput) {
        sellingPlanInput.value = '';
        if (priceDisplay) priceDisplay.style.display = 'none';
        if (regularPrice) regularPrice.style.display = 'block';
      }
    });
  });

  // ============================================================
  // Newsletter Form Feedback
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('newsletter-form') ||
               document.querySelector('.newsletter-section__form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      // Shopify handles the form submission — show feedback after redirect
      var emailInput = form.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        // Store success flag for after redirect
        sessionStorage.setItem('newsletter_submitted', '1');
      }
    });

    // Check if we just submitted
    if (sessionStorage.getItem('newsletter_submitted')) {
      sessionStorage.removeItem('newsletter_submitted');
      var statusEl = document.createElement('div');
      statusEl.className = 'newsletter-section__success';
      statusEl.textContent = 'Thank you for subscribing!';
      statusEl.style.cssText = 'text-align:center;color:#2d5f3f;font-size:14px;font-weight:600;padding:12px 0;';
      var section = document.querySelector('.newsletter-section__inner');
      if (section) {
        var formEl = section.querySelector('form');
        if (formEl) formEl.style.display = 'none';
        section.appendChild(statusEl);
      }
    }
  });

  // ============================================================
  // Mobile Menu
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    var closeBtn = document.querySelector('[data-mobile-menu-close]');
    var menu = document.querySelector('[data-mobile-menu]');

    if (openBtn && menu) {
      openBtn.addEventListener('click', function() {
        menu.hidden = false;
        menu.style.display = 'block';
        document.body.style.overflow = 'hidden';
      });
    }
    if (closeBtn && menu) {
      closeBtn.addEventListener('click', function() {
        menu.hidden = true;
        menu.style.display = 'none';
        document.body.style.overflow = '';
      });
    }
    // Close on backdrop click
    if (menu) {
      menu.addEventListener('click', function(e) {
        if (e.target === menu) {
          menu.hidden = true;
          menu.style.display = 'none';
          document.body.style.overflow = '';
        }
      });
    }
  });

  // ============================================================
  // Variant Selector (Default Title fix)
  // ============================================================
  document.addEventListener('DOMContentLoaded', function() {
    // Hide variant selector if only "Default Title" exists
    var selectors = document.querySelectorAll('.product-form__input');
    selectors.forEach(function(sel) {
      var label = sel.querySelector('legend, label');
      if (label && label.textContent.trim() === 'Default Title') {
        sel.style.display = 'none';
      }
    });
  });
})();
